const LGC_CART_TERMS_BLOCK = "[data-lgc-cart-terms]";
const LGC_CART_TERMS_CHECKBOX = "[data-lgc-cart-terms-checkbox]";
const LGC_CART_TERMS_SCOPE = "#main-cart-footer, .cart-drawer__footer, .drawer__footer, .cart__ctas";
const LGC_CHECKOUT_BUTTON = '[name="checkout"], .cart__checkout-button';

function getCartTermsStorageKey(scopeName) {
  return `lgc-cart-terms:${scopeName || "cart"}`;
}

function readCartTermsState(scopeName) {
  try {
    return sessionStorage.getItem(getCartTermsStorageKey(scopeName)) === "true";
  } catch (_) {
    return false;
  }
}

function writeCartTermsState(scopeName, isAccepted) {
  try {
    sessionStorage.setItem(getCartTermsStorageKey(scopeName), isAccepted ? "true" : "false");
  } catch (_) {}
}

// Walks outwards from the checkout button so the matching block is found even when
// the cart page and the cart drawer are both present in the DOM.
function findCartTermsBlock(element) {
  if (!element) return null;

  const ownBlock = element.closest?.(LGC_CART_TERMS_BLOCK);
  if (ownBlock) return ownBlock;

  const formId = element.getAttribute?.("form");
  if (formId) {
    const relatedForm = document.getElementById(formId);
    if (relatedForm) {
      const relatedBlock = findCartTermsBlockForForm(relatedForm);
      if (relatedBlock) return relatedBlock;
    }
  }

  // Stops before <body> so unrelated checkout buttons (e.g. cart notification) are not matched.
  let node = element.parentElement;
  while (node && node !== document.body) {
    const block = node.querySelector(LGC_CART_TERMS_BLOCK);
    if (block) return block;
    node = node.parentElement;
  }

  return null;
}

function findCartTermsBlockForForm(form) {
  const checkbox = Array.from(document.querySelectorAll(LGC_CART_TERMS_CHECKBOX)).find((input) => input.form === form);
  return checkbox ? checkbox.closest(LGC_CART_TERMS_BLOCK) : null;
}

function syncCartTermsBlock(termsBlock) {
  if (!termsBlock) return;

  const checkbox = termsBlock.querySelector(LGC_CART_TERMS_CHECKBOX);
  if (!checkbox) return;

  const scope = termsBlock.closest(LGC_CART_TERMS_SCOPE) || termsBlock.parentElement;
  const error = termsBlock.querySelector("[data-lgc-cart-terms-error]");
  const isAccepted = checkbox.checked;
  const wasTouched = termsBlock.dataset.lgcCartTermsTouched === "true";

  if (scope) {
    scope.querySelectorAll(LGC_CHECKOUT_BUTTON).forEach((button) => {
      if (!button.hasAttribute("data-lgc-originally-disabled")) {
        button.setAttribute("data-lgc-originally-disabled", String(button.disabled));
      }

      const isDisabledByCart = button.getAttribute("data-lgc-originally-disabled") === "true";
      button.disabled = isDisabledByCart || !isAccepted;
      button.setAttribute("aria-disabled", String(button.disabled));
    });

    const footerScope = termsBlock.closest("#main-cart-footer, .cart-drawer__footer, .drawer__footer") || scope;
    footerScope.querySelectorAll(".cart__dynamic-checkout-buttons").forEach((area) => {
      area.classList.toggle("lgc-cart-terms-disabled", !isAccepted);
      area.setAttribute("aria-hidden", String(!isAccepted));
    });
  }

  if (error) {
    error.hidden = isAccepted || !wasTouched;
  }

  writeCartTermsState(termsBlock.dataset.lgcCartTermsScope, isAccepted);
}

function rejectCartTerms(termsBlock) {
  termsBlock.dataset.lgcCartTermsTouched = "true";
  syncCartTermsBlock(termsBlock);

  const error = termsBlock.querySelector("[data-lgc-cart-terms-error]");
  if (error) error.hidden = false;

  termsBlock.querySelector(LGC_CART_TERMS_CHECKBOX)?.focus();
}

function initCartTermsAcceptance() {
  document.querySelectorAll(LGC_CART_TERMS_BLOCK).forEach((termsBlock) => {
    const checkbox = termsBlock.querySelector(LGC_CART_TERMS_CHECKBOX);
    if (!checkbox) return;

    // A cart update re-renders the footer, so restore the stored state on each new block.
    if (termsBlock.dataset.lgcCartTermsReady !== "true") {
      termsBlock.dataset.lgcCartTermsReady = "true";
      checkbox.checked = readCartTermsState(termsBlock.dataset.lgcCartTermsScope);
    }

    syncCartTermsBlock(termsBlock);
  });
}

document.addEventListener("change", (event) => {
  const checkbox = event.target.closest?.(LGC_CART_TERMS_CHECKBOX);
  const termsBlock = checkbox?.closest(LGC_CART_TERMS_BLOCK);
  if (!termsBlock) return;

  termsBlock.dataset.lgcCartTermsTouched = "true";
  syncCartTermsBlock(termsBlock);
});

document.addEventListener(
  "click",
  (event) => {
    const checkoutButton = event.target.closest?.(LGC_CHECKOUT_BUTTON);
    if (!checkoutButton) return;

    const termsBlock = findCartTermsBlock(checkoutButton);
    const checkbox = termsBlock?.querySelector(LGC_CART_TERMS_CHECKBOX);
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopPropagation();
    rejectCartTerms(termsBlock);
  },
  true
);

document.addEventListener(
  "submit",
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const termsBlock = findCartTermsBlockForForm(form);
    const checkbox = termsBlock?.querySelector(LGC_CART_TERMS_CHECKBOX);
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopPropagation();
    rejectCartTerms(termsBlock);
  },
  true
);

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartTermsAcceptance);
} else {
  initCartTermsAcceptance();
}

document.addEventListener("shopify:section:load", initCartTermsAcceptance);

// The wholesale app replaces the checkout button with an unguarded clone once it finishes rendering.
window.addEventListener("samitaWSRenderWholesaleCompleted", initCartTermsAcceptance);

if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
  subscribe(PUB_SUB_EVENTS.cartUpdate, initCartTermsAcceptance);
}

if (document.body) {
  let cartTermsSyncScheduled = false;

  new MutationObserver(() => {
    if (cartTermsSyncScheduled) return;
    cartTermsSyncScheduled = true;
    requestAnimationFrame(() => {
      cartTermsSyncScheduled = false;
      initCartTermsAcceptance();
    });
  }).observe(document.body, { childList: true, subtree: true });
}
